import React, {useContext, useEffect} from 'react';
import HorizontalStepperContainer from "./HorizontalStepperContainer";
import {Container, Paper, Stack, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {UserContext} from "../context";

const OvercomeNegativeThought = () => {
    const user = useContext(UserContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (user == null) {
            navigate('/');
        }
    }, [navigate, user]);

    return user && (
        <Container maxWidth="md" sx={{py: 4}}>
            <Stack spacing={4}>
                <Paper elevation={0} sx={{p: {xs: 4, md: 6}, backgroundColor: 'grey.50'}}>
                    <Stack spacing={2}>
                        <Typography variant="h3" sx={{
                            fontWeight: 800,
                            background: '-webkit-linear-gradient(45deg, #42A5F5, #EF5350 80%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent'
                        }}>
                            Overcome Negative Thoughts
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                            In this activity, you’ll answer questions that you can use in real life to increase hope and control and feel better.
                        </Typography>
                    </Stack>
                </Paper>
                <HorizontalStepperContainer />
            </Stack>
        </Container>
    );
};

export default OvercomeNegativeThought;
